import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import LoginHeader from './Login_header';
import Menu from './Menu'

function Home() {
    return (
        <>
            <LoginHeader />
            <Menu />
            <Container >

                {
                    sessionStorage.isLive === 'true' ? <>
                        <Row>
                            <Col>
                                <div className='greenWarning'>
                                    This is live. Only for Live entries.
                                </div>

                            </Col>
                        </Row>
                    </> : <>
                        <Row >
                            <Col>
                                <div className='redWarning'>
                                    This is UAT setup Only for dummy Entries.
                                </div>
                            </Col>
                        </Row>
                    </>
                }

            </Container>

        </>
    )
}

export default Home
